import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/sales-orders',
    title: 'Webshop Narudžbe',
    Component: IndexPage,
} satisfies RouteObject;
